import React, { Component } from 'react';
import Page from '../../containers/page';
import FormBuilder from '../../form-builder';
import RouteComponent from '../../helpers/route';
import ListBuilder from '../../list-builder';
import Isvg from 'react-inlinesvg';
import {
    Row,
    Col,
    Table,
    FormGroup, Label, Input
} from 'reactstrap';
import editIcon from '../../assets/edit.svg';
import garbageIcon from '../../assets/garbage.svg';
import saveIcon from '../../assets/save.svg';
import printIcon from '../../assets/print.svg';
import garbageOpionIcon from '../../assets/garbage-option.svg';
import DeleteModal from '../../components/deleteModal';
import { required, number, minValue, maxValue, minLength, maxLength, length, email } from '../../form-builder/validation';


class Home extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            articlesList: true,
            articleForm: false,
            total: 20,
            items: [

            ],
            articleTypes: [],
            groups: [],
            subgroups: [],
            manufacturers: [],
            atc: [],
            shapes: [],
            modes: [],
            attributes: [],
            categories: []
        }
    }



    componentDidMount() {
        this._onLoad();

        this._api('categories', {}, (data) => {
            this.setState({ categories: data.categories })
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props[0].location.search != prevProps[0].location.search) {
            this._onLoad();
        }
    }

    render() {
        let params = this._getParams();

        console.log(this.state.categories)
        return (
            <div>
                <div className="section-title title-options">
                    <h1>{'Stock clients'.translate(this.props.lang)}</h1>
                </div>
                {this.state.articleForm ?
                    <div className="table-tabs">
                        <button onClick={() => this.setState({ articleForm: false })}>
                            {'List'.translate(this.props.lamg)}
                        </button>
                        <button className="active" onClick={() => this.setState({ articleForm: {} })}>
                            {'Add new'.translate(this.props.lang)}
                        </button>
                    </div>
                    : null}

                {
                    this.state.articleForm ?

                        <div>
                            <div className="side-margin">
                                <FormBuilder
                                    registerSubmitAction={(submit) => this.submit = submit}
                                    classNameForm={"add-form-container"}
                                    // headerForm={"Article".translate(this.props.lang)}
                                    //                                  addButtonText={this.state.articleForm._id ? 'Edit product'.translate(this.props.lang) :  'Add new'.translate(this.props.lang)}
                                    lang={this.props.lang}
                                    onSubmit={(data) => {

                                        if (this.state.articleForm && this.state.articleForm._id) {
                                            console.log(data)
                                            this._api('api4', { data: data }, () => {
                                                this.setState({ articleForm: undefined }, () => { this._onLoad(); })
                                            });
                                        } else {
                                            console.log(data)
                                            this._api('api2', { data: data }, () => {
                                                this.setState({ articleForm: {} }, () => { this._onLoad() })
                                            });
                                        }
                                    }}
                                    initialValues={this.state.articleForm && this.state.articleForm._id ? this.state.articleForm : {}}
                                    fields={[
                                        {
                                            type: 'row',
                                            children: [
                                                {
                                                    type: 'col',
                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'E-mail'.translate(this.props.lang),
                                                            style: { paddingBottom: 33, marginBottom: 20 },
                                                            children: [
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'textarea',
                                                                            name: 'email.to',
                                                                            next: 'password',
                                                                            label: 'To',
                                                                            
                                                                        },
                                                                
                                                                    ]
                                                                },
                                                               
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'title',
                                                                            text: 'XLSX'.translate(this.props.lang),

                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email.xlsx.filename',
                                                                            next: 'password',
                                                                            label: 'Filename',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'select',
                                                                            name: 'email.xlsx.template',
                                                                            next: 'password',
                                                                            label: 'Template',
                                                                            values: [
                                                                                {
                                                                                    name: '-',
                                                                                    value: null
                                                                                },
                                                                                {
                                                                                name: 'Standard',
                                                                                value: 'standard'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (sku,stock)',
                                                                                value: 'sku-stock'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (ItemNum,Qry)',
                                                                                value: 'sku-stock-v2'
                                                                            },
                                                                            {
                                                                                name: 'Three cols (sku,is_variant,stock)',
                                                                                value: 'sku-stock-v3'
                                                                            },

                                                                        ]
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email.xlsx.schedule',
                                                                            next: 'password',
                                                                            label: 'Schedule',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email.xlsx.customerId',
                                                                            next: 'password',
                                                                            label: 'Customer Id',
                                                                            
                                                                        },


                                                                        {
                                                                            type: 'title',
                                                                            text: 'CSV'.translate(this.props.lang),

                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email.csv.filename',
                                                                            next: 'password',
                                                                            label: 'Filename',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'select',
                                                                            name: 'email.csv.template',
                                                                            next: 'password',
                                                                            label: 'Template',
                                                                            values: [
                                                                                {
                                                                                    name: '-',
                                                                                    value: null
                                                                                },
                                                                                {
                                                                                name: 'Standard',
                                                                                value: 'standard'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (sku,stock)',
                                                                                value: 'sku-stock'
                                                                            },
									    {
                                                                                name: 'Two cols (sku,quantity)',
                                                                                value: 'sku-quantity'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (ItemNum,Qry)',
                                                                                value: 'sku-stock-v2'
                                                                            },
                                                                            {
                                                                                name: 'Three cols (sku,is_variant,stock)',
                                                                                value: 'sku-stock-v3'
                                                                            },
										    {
                                                                                name: 'EAN Quantity',
                                                                                value: 'ean-quantity'
                                                                            },

                                                                        ]
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email.csv.schedule',
                                                                            next: 'password',
                                                                            label: 'Schedule',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email.csv.customerId',
                                                                            next: 'password',
                                                                            label: 'Customer Id',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'title',
                                                                            text: 'XML'.translate(this.props.lang),

                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email.xml.filename',
                                                                            next: 'password',
                                                                            label: 'Filename',

                                                                        },
                                                                        {
                                                                            type: 'select',
                                                                            name: 'email.xml.template',
                                                                            next: 'password',
                                                                            label: 'Template',
                                                                            values: [
                                                                                {
                                                                                    name: '-',
                                                                                    value: ''
                                                                                },
                                                                                {
                                                                                    name: 'Two cols (sku,stock)',
                                                                                    value: 'sku-stock'
                                                                                },
                                                                            ]

                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email.xml.schedule',
                                                                            next: 'password',
                                                                            label: 'Schedule',

                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email.xml.customerId',
                                                                            next: 'password',
                                                                            label: 'Customer Id',

                                                                        },

                                                                    ]
                                                                },


                            
                                                        
                                                               

                                                            ]
                                                        },




                                                        {
                                                            type: 'block',
                                                            header: 'FTP'.translate(this.props.lang),
                                                            style: { paddingBottom: 33, marginBottom: 20 },
                                                            children: [
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.host',
                                                                            next: 'password',
                                                                            label: 'Host',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.port',
                                                                            next: 'password',
                                                                            label: 'Port',
                                                                            
                                                                        },

                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.username',
                                                                            next: 'password',
                                                                            label: 'Username',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.password',
                                                                            next: 'password',
                                                                            label: 'Password',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'switch',
                                                                            name: 'ftp.secure',
                                                                            next: 'password',
                                                                            label: 'Secure',
                                                                            
                                                                        },

                                                                        {
                                                                            type: 'switch',
                                                                            name: 'ftp.secureOptions.rejectUnauthorized',
                                                                            next: 'password',
                                                                            label: 'Reject Unauthorized',
                                                                            
                                                                        },



                                                                    ]
                                                                },
                                                               
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'title',
                                                                            text: 'XLSX'.translate(this.props.lang),

                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.xlsx.filename',
                                                                            next: 'password',
                                                                            label: 'Filename',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'select',
                                                                            name: 'ftp.xlsx.template',
                                                                            next: 'password',
                                                                            label: 'Template',
                                                                            values: [
                                                                                {
                                                                                    name: '-',
                                                                                    value: null
                                                                                },
                                                                                {
                                                                                name: 'Standard',
                                                                                value: 'standard'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (sku,stock)',
                                                                                value: 'sku-stock'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (ItemNum,Qry)',
                                                                                value: 'sku-stock-v2'
                                                                            },
                                                                            {
                                                                                name: 'Three cols (sku,is_variant,stock)',
                                                                                value: 'sku-stock-v3'
                                                                            },

                                                                        ]
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.xlsx.schedule',
                                                                            next: 'password',
                                                                            label: 'Schedule',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.xlsx.customerId',
                                                                            next: 'password',
                                                                            label: 'Customer Id',
                                                                            
                                                                        },

                                                                        {
                                                                            type: 'title',
                                                                            text: 'CSV'.translate(this.props.lang),

                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.csv.filename',
                                                                            next: 'password',
                                                                            label: 'Filename',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'select',
                                                                            name: 'ftp.csv.template',
                                                                            next: 'password',
                                                                            label: 'Template',
                                                                            values: [
                                                                                {
                                                                                    name: '-',
                                                                                    value: null
                                                                                },
                                                                                {
                                                                                name: 'Standard',
                                                                                value: 'standard'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (sku,stock)',
                                                                                value: 'sku-stock'
                                                                            },
										    {
                                                                                name: 'Two cols (sku,quantity)',
                                                                                value: 'sku-quantity'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (ItemNum,Qry)',
                                                                                value: 'sku-stock-v2'
                                                                            },
                                                                            {
                                                                                name: 'Three cols (sku,is_variant,stock)',
                                                                                value: 'sku-stock-v3'
                                                                            },
										    {
                                                                                name: 'EAN Quantity',
                                                                                value: 'ean-quantity'
                                                                            },

                                                                        ]
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.csv.schedule',
                                                                            next: 'password',
                                                                            label: 'Schedule',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'ftp.csv.customerId',
                                                                            next: 'password',
                                                                            label: 'Customer Id',
                                                                            
                                                                        },
									{
                                                                            type: 'textarea',
                                                                            name: 'ftp.csv.zeroSkus',
                                                                            next: 'password',
                                                                            label: 'SKUS [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[0].from',
                                                                            next: 'password',
                                                                            label: 'From [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[0].to',
                                                                            next: 'password',
                                                                            label: 'To [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[1].from',
                                                                            next: 'password',
                                                                            label: 'From [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[1].to',
                                                                            next: 'password',
                                                                            label: 'To [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[2].from',
                                                                            next: 'password',
                                                                            label: 'From [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[2].to',
                                                                            next: 'password',
                                                                            label: 'To [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[3].from',
                                                                            next: 'password',
                                                                            label: 'From [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[3].to',
                                                                            next: 'password',
                                                                            label: 'To [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[4].from',
                                                                            next: 'password',
                                                                            label: 'From [inStock=0]',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            textType: 'date',
                                                                            name: 'ftp.csv.zeroSkusDates[4].to',
                                                                            next: 'password',
                                                                            label: 'To [inStock=0]',
                                                                            
                                                                        },

                                                                    ]
                                                                },


                            
                                                        





                                                                
                                                               

                                                            ]
                                                        },









                                                        {
                                                            type: 'block',
                                                            header: 'SFTP'.translate(this.props.lang),
                                                            style: { paddingBottom: 33 },
                                                            children: [
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.host',
                                                                            next: 'password',
                                                                            label: 'Host',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.port',
                                                                            next: 'password',
                                                                            label: 'Port',
                                                                            
                                                                        },

                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.username',
                                                                            next: 'password',
                                                                            label: 'Username',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.password',
                                                                            next: 'password',
                                                                            label: 'Password',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'textarea',
                                                                            name: 'sftp.privateKey',
                                                                            next: 'password',
                                                                            label: 'Private key',
                                                                            
                                                                        },



                                                                    ]
                                                                },
                                                               
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'title',
                                                                            text: 'XLSX'.translate(this.props.lang),

                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.xlsx.filename',
                                                                            next: 'password',
                                                                            label: 'Filename',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'select',
                                                                            name: 'sftp.xlsx.template',
                                                                            next: 'password',
                                                                            label: 'Template',
                                                                            values: [
                                                                                {
                                                                                    name: '-',
                                                                                    value: null
                                                                                },
                                                                                {
                                                                                name: 'Standard',
                                                                                value: 'standard'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (sku,stock)',
                                                                                value: 'sku-stock'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (ItemNum,Qry)',
                                                                                value: 'sku-stock-v2'
                                                                            },
                                                                            {
                                                                                name: 'Three cols (sku,is_variant,stock)',
                                                                                value: 'sku-stock-v3'
                                                                            },

                                                                        ]
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.xlsx.schedule',
                                                                            next: 'password',
                                                                            label: 'Schedule',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.xlsx.customerId',
                                                                            next: 'password',
                                                                            label: 'Customer Id',
                                                                            
                                                                        },

                                                                        {
                                                                            type: 'title',
                                                                            text: 'CSV'.translate(this.props.lang),

                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.csv.filename',
                                                                            next: 'password',
                                                                            label: 'Filename',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'select',
                                                                            name: 'sftp.csv.template',
                                                                            next: 'password',
                                                                            label: 'Template',
                                                                            values: [
                                                                                {
                                                                                    name: '-',
                                                                                    value: null
                                                                                },
                                                                                {
                                                                                name: 'Standard',
                                                                                value: 'standard'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (sku,stock)',
                                                                                value: 'sku-stock'
                                                                            },
										    {
                                                                                name: 'Two cols (sku,quantity)',
                                                                                value: 'sku-quantity'
                                                                            },
                                                                            {
                                                                                name: 'Two cols (ItemNum,Qry)',
                                                                                value: 'sku-stock-v2'
                                                                            },
                                                                            {
                                                                                name: 'Three cols (sku,is_variant,stock)',
                                                                                value: 'sku-stock-v3'
                                                                            },
									    {
                                                                                name: 'Kaufland',
                                                                                value: 'kaufland'
                                                                            },
									{
                                                                                name: 'EAN Quantity',
                                                                                value: 'ean-quantity'
                                                                            },
                                                                                {
                                                                                    name: 'EAN Quantity Restock date',
                                                                                    value: 'ean-quantity-restock-date'
                                                                                }

                                                                        ]
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.csv.schedule',
                                                                            next: 'password',
                                                                            label: 'Schedule',
                                                                            
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sftp.csv.customerId',
                                                                            next: 'password',
                                                                            label: 'Customer Id',
                                                                            
                                                                        },

                                                                    ]
                                                                },


                            
                                                        





                                                                
                                                               

                                                            ]
                                                        },




                                                    ]
                                                },
                                              




                                            


                                            ],
                                        },
                                        {
                                            type: 'row',
                                            children: [
                                                {
                                                    type: 'button',
                                                    width: { lg: 4, sm: 6, xs: 6 },
                                                    action: 'submit',
                                                    children: 'Save',
                                                    className: 'form-button',
                                                },

                                            ]
                                        }

                                    ]}
                                ></FormBuilder>
                            </div>

                        </div>

                        :

                        <div>
                            <DeleteModal
                                isOpen={this.state.deleteModal}
                                toggle={() => this.setState({ deleteModal: null })}
                                handler={() => {
                                    this._api('api3', { data: this.state.deleteModal._id }, () => {
                                        this.setState({ groupsForm: {} }, () => { this._onLoad(); this.setState({ deleteModal: null }) })
                                    });
                                }} >
                                {'Delete client'.translate(this.props.lang)}?
                            </DeleteModal>
                            <ListBuilder
                                tabs={true}
                                sort={true}
                                tab1Name={'List'.translate(this.props.lang)}
                                tab2Name={"Add new".translate(this.props.lang)}
                                onClickTab1={() => {
                                    this.setState({
                                        articlesList: true,
                                        articleForm: false,
                                    })
									  this.updateMultipleParams([{ name: 'entries', value:"10" }, { name: 'page', value: 0 },{name: 'filter',value: ''}], true);
                                }}
                                onClickTab2={() => {
                                    this.setState({
                                        articleForm: true,
                                        articlesList: false
                                    })
                                }}
                                lang={this.props.lang}
                                loading={this.state.loading}
                                total={this.state.total}
                                showNumeration={false}
                                fields={[
                                    { type: 'text', name: 'email.to', label: 'EMAIL'.translate(this.props.lang), allowSort: true },
                                    { type: 'text', name: 'ftp.host', label: 'FTP'.translate(this.props.lang), allowSort: true },
                                    { type: 'text', name: 'sftp.host', label: 'SFTP'.translate(this.props.lang), allowSort: true },


                                ]}
                                items={this.state.items}
                                actions={
                                    [
                                        {
                                            component: <Isvg src={editIcon} />,
                                            onClick: (item) => this.setState({ articleForm: item })
                                        },
                                        {
                                            component: <Isvg src={garbageIcon} />,
                                            onClick: (item) => this.setState({ deleteModal: item })
                                        },
                                    ]
                                }

                                params={params}
                                sortField={params.sortField}
                                sortType={params.sortType}
                                updateSort={this.updateSort}
                                updateParams={this.updateParams}
                                updateMultipleParams={this.updateMultipleParams}
                            ></ListBuilder>
                        </div>
                }


            </div>
        )
    }
}

export default Page(Home);

/*

*/
